module.exports = __webpack_public_path__ + "img/watch-apple.b64c50a9.svg";